export default __webpack_public_path__ + "static/media/cny-lucky-draw-cn.00233cb6.webp";